import { render, staticRenderFns } from "./BaseTabs.vue?vue&type=template&id=3e3b9b22&scoped=true"
import script from "./BaseTabs.vue?vue&type=script&lang=js"
export * from "./BaseTabs.vue?vue&type=script&lang=js"
import style0 from "./BaseTabs.vue?vue&type=style&index=0&id=3e3b9b22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3b9b22",
  null
  
)

export default component.exports